import { graphql } from '@prophecy/graphql-types/graphql';
// Home (project-less) conversations. `projectUID: null` stays a literal: metagraph routes to the
// home branch only when the argument is present and null; omitting it is an error.
// Each chat has two rows: `user` (the chat elements the UI renders) and `agent` (the Claude session file).
export const GetHomeConversations = graphql(`
  query GetHomeConversations($limit: Int!, $offset: Int, $teamUID: String) {
    getLastNConversations(projectUID: null, limit: $limit, offset: $offset, teamUID: $teamUID) {
      conversationId
      name
      nameSource
      teamUID
      createdAt
      updatedAt
    }
  }
`);
export const GetHomeConversationContent = graphql(`
  query GetHomeConversationContent($conversationId: String!, $promptOffset: Int!, $promptLimit: Int!) {
    getConversationContentPaginated(
      projectUID: null
      conversationId: $conversationId
      type: "user"
      promptOffset: $promptOffset
      promptLimit: $promptLimit
    ) {
      content
      totalPromptCount
      hasMore
      name
    }
  }
`);
export const CreateHomeConversation = graphql(`
  mutation CreateHomeConversation($name: String!, $conversationId: String!, $teamUID: String) {
    addAgentConversation(projectUID: null, name: $name, conversationId: $conversationId, teamUID: $teamUID) {
      _id
      conversationId
      type
      name
      nameSource
      projectUID
      branch
      teamUID
      createdAt
      updatedAt
    }
  }
`);
export const RenameHomeConversation = graphql(`
  mutation RenameHomeConversation($conversationId: String!, $name: String!) {
    updateConversationName(projectUID: null, conversationId: $conversationId, name: $name, nameSource: manual)
  }
`);
/** An agent-chosen title: `auto` never overwrites a name the user set. */
export const AutoNameHomeConversation = graphql(`
  mutation AutoNameHomeConversation($conversationId: String!, $name: String!) {
    updateConversationName(projectUID: null, conversationId: $conversationId, name: $name, nameSource: auto)
  }
`);
export const DeleteHomeConversation = graphql(`
  mutation DeleteHomeConversation($conversationId: String!) {
    removeAgentConversationByType(projectUID: null, conversationId: $conversationId)
  }
`);
export const GetHomeAgentSession = graphql(`
  query GetHomeAgentSession($conversationId: String!) {
    getConversationByType(projectUID: null, conversationId: $conversationId, type: "agent") {
      _id
      content
      createdAt
      updatedAt
    }
  }
`);
export const WriteHomeAgentSession = graphql(`
  mutation WriteHomeAgentSession($conversationId: String!, $content: String!) {
    writeAgentConversationByType(
      projectUID: null
      conversationId: $conversationId
      conversationType: "agent"
      content: $content
    )
  }
`);
export const AppendHomeTranscript = graphql(`
  mutation AppendHomeTranscript($conversationId: String!, $content: String!) {
    updateAgentConversationByType(
      projectUID: null
      conversationId: $conversationId
      conversationType: "user"
      content: $content
    )
  }
`);
